import { CardType } from 'components/IndiaOrGlobalModal/Content';
import {
  LANDING_PAGE_URL,
  INDIAN_EXCHANGE_DOMAIN,
  GLOBAL_EXCHANGE_DOMAIN,
} from 'constants/index';

const shouldRedirectRelativeRoute =
  process.env.REACT_APP_SHOULD_REDIRECT_RELATIVE_ROUTE === 'true';

const hasHostname = (urlString: string): boolean => {
  try {
    const url = new URL(urlString);
    return !!url.href;
  } catch (e) {
    return false;
  }
};

const getHostName = () => {
  return shouldRedirectRelativeRoute ? window.location.origin : LANDING_PAGE_URL;
};

const navigateTo = (path: string, target?: string, windowFeatures?: string) => {
  const endpoint = getHostName();
  let redirectTo;

  if (hasHostname(path)) {
    redirectTo = path;
  } else {
    redirectTo = `${endpoint}${path.startsWith('/') ? path : `/${path}`}`;
  }
  window.open(redirectTo, target || '_self', windowFeatures);
};

const generateExchangeURL = (exchange: CardType) => {
  if (exchange === CardType.INDIA) {
    return INDIAN_EXCHANGE_DOMAIN;
  }

  return GLOBAL_EXCHANGE_DOMAIN;
};

export {
  shouldRedirectRelativeRoute,
  hasHostname,
  getHostName,
  navigateTo,
  generateExchangeURL,
};
